export const PURCHASE_PAGE_PRODSELECT = '/purchase/product-select';
export const PURCHASE_PAGE_LOGIN = '/purchase/login';
export const PURCHASE_PAGE_CHECKOUT = '/purchase/checkout';
export const PURCHASE_PAGE_CHECKOUT_VERIFY = '/purchase/checkout-verify';
export const PURCHASE_PAGE_DONE = '/purchase/done';
